export default __webpack_public_path__ + "static/media/TVinsure-Covid-Test-md-long.ff71506f.jpg";